import { render, staticRenderFns } from "./electrician.vue?vue&type=template&id=cb19edba&scoped=true&"
import script from "./electrician.vue?vue&type=script&lang=js&"
export * from "./electrician.vue?vue&type=script&lang=js&"
import style0 from "./electrician.vue?vue&type=style&index=0&id=cb19edba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb19edba",
  null
  
)

export default component.exports